module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAANCAYAAACdKY9CAAAAAXNSR0IArs4c6QAAAL1JREFUKFOdUjsKwlAQnImosdV7GKwVRAtzCUHRK9h4GEHPYJUqWFhrLiMGkowk5PMgIaKv2re7Mzs77xHG8W7BBolOADp5OobFvTt3LkUbi8DzgzegvklQxQzdhWOn9wzQ3lxyZyDmMs5lmrgqwRTEsDbN4pae/4wMzVDYHVl2dJB0bJAXpwCZhS8ANALYi9agdqAIcWwS1iRRmq2Wk3vl3uMFcFDYXFu62dY8my79s61/PVwJ+uVrtGo3ih9Z9WF4g64JgQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/layout/components/images/time.png
// module id = kGA1
// module chunks = 6